import { create } from "zustand";

import type { User } from "./types";

const initialState = {
  error: null,
  loading: [],
  user: null,
};

interface GlobalStore {
  error: string | null;
  loading: string[];
  user: User | null;
  setUser: (user: User) => void;
}

export const useStore = create<GlobalStore>((set) => ({
  ...initialState,
  setUser: (userInfo: User) => set({ user: userInfo }),
  reset: () => set(initialState),
}));
